const localeEs = {
  // Error view
  UDE_BUNDLES_ERROR: 'Ocurrió un error al obtener tus certificaciones',
  // Bundle card
  UDE_BUNDLE_COMPLETED: 'Certificación completada',
};
export default localeEs;
